import Api from 'libs/api';

class PromotionsApi extends Api {
  constructor() {
    super('admin/promotions/');
  }
}

export default PromotionsApi;
